<template>
  <v-toolbar-items v-if="!list" class="hidden-sm-and-down">
    <v-btn v-for="item in links" flat v-if="item.visible" :key="item.name" :to="item.to">{{item.name}}</v-btn>
  </v-toolbar-items>
  <v-list v-else dense>
    <v-list-tile v-if="item.visible" v-for="item in links" :key="item.name" :to="item.to" v-tooltip="{content: mini ? item.name : null}">
      <v-list-tile-action >
        <v-icon >{{item.icon}}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content >
        <v-list-tile-title>{{item.name}}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    mini: Boolean,
    list: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isTrainer', 'isRunner', 'authUser']),
    links () {
      return [
        {visible: true, to: {name: 'runner-data', params: {id: this.$route.params.id}}, name: 'Dane', icon: 'person'},
        {visible: true, to: {name: 'runner-plan', params: {id: this.$route.params.id}}, name: 'Plan treningowy', icon: 'calendar_today'},
        {visible: true, to: {name: 'runner-hrmax', params: {id: this.$route.params.id}}, name: 'Badania', icon: 'favorite_border'},
        {visible: true, to: {name: 'runner-pages', params: {id: this.$route.params.id, slug: 'discounts'}}, name: 'Zniżki', icon: 'card_giftcard'},
        {visible: true, to: {name: 'runner-pages', params: {id: this.$route.params.id, slug: 'explanations'}}, name: 'Objaśnienia', icon: 'contact_support'},
        {visible: true, to: {name: 'runner-progression', params: {id: this.$route.params.id}}, name: 'Rekordy', icon: 'show_chart'},
        {visible: true, to: {name: 'runner-races', params: {id: this.$route.params.id}}, name: 'Zawody', icon: 'directions_run'},
        {visible: true, to: {name: 'runner-payments', params: {id: this.$route.params.id}}, name: 'Płatności', icon: 'attach_money'},
        {visible: true, to: {name: 'runner-videos', params: {id: this.$route.params.id}}, name: 'Filmy', icon: 'movie'},
        {visible: true, to: {name: 'runner-notifications', params: {id: this.$route.params.id}}, name: 'Powiadomienia', icon: 'notifications'},
        {visible: true, to: {name: 'runner-forum', params: {id: this.$route.params.id}}, name: 'Forum', icon: 'forum'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/RunnerNav.vue